import React from "react";

const Label = ({ children } : {children: any}) => {
  return (
    <label className="block text-sm font-medium text-gray-700">
      {children}
    </label>
  );
};

export default Label;
